import React from 'react';
import { faTrash } from '@fortawesome/pro-solid-svg-icons/faTrash';
import { useIntl } from 'react-intl';

import { IconButton } from 'ui-components/components/button/icon-button';
import { Tag, TagType } from 'ui-components/components/tag';
import { Text, TextType } from 'ui-components/components/text';

import { messages } from './messages';
import style from './style.module.less';
import { useSellerFormattedDate, useSellerFormattedTime } from '../../../../../hooks/use-datetime-formats';
import { getIsApiKeyExpiringSoon } from '../../hooks/helpers';
import { ApiKey } from '../api-key';

/**
 * @param {object} props
 * @param {import('../../types/api-keys').APIKeysV1} props.v1ApiKey
 * @param {(apiKeyId: number) => void} props.onDeleteClick
 * @returns {JSX.Element} The rendered component.
 */
export const ApiKeysV1Item = ({ v1ApiKey, onDeleteClick }) => {
  const intl = useIntl();

  const creationDate = useSellerFormattedDate(v1ApiKey.createDateTime);
  const expirationDate = useSellerFormattedDate(v1ApiKey.expireDateTime);
  const expirationHour = useSellerFormattedTime(v1ApiKey.expireDateTime);

  const isExpired = new Date().getTime() > new Date(v1ApiKey.expireDateTime).getTime();
  const isExpiringSoon = !isExpired && getIsApiKeyExpiringSoon(v1ApiKey.expireDateTime);

  const onDeleteButtonClick = () => onDeleteClick(v1ApiKey.keyId);

  return (
    <tr className={style['api-keys-v1-table-tr']}>
      <td className={style['api-keys-v1-table-td']}>
        <ApiKey value={v1ApiKey.key} />
      </td>
      <td className={style['api-keys-v1-table-td']}>
        <Text textType={TextType.Paragraph} value={creationDate} />
      </td>
      <td className={style['api-keys-v1-table-td']}>
        <Text
          textType={TextType.Paragraph}
          value={intl.formatMessage(messages.expirationDate, {
            date: expirationDate,
            hour: expirationHour,
          })}
        />
      </td>
      <td className={style['api-keys-v1-table-td']}>
        {isExpiringSoon ? <Tag message={intl.formatMessage(messages.expiringSoonTag)} type={TagType.Warning} /> : null}
        {isExpired ? <Tag message={intl.formatMessage(messages.expiredTag)} type={TagType.Warning} /> : null}
      </td>
      <td className={style['api-keys-v1-table-td']}>
        <IconButton ariaLabelMessageDescriptor={messages.ariaTrashIcon} icon={faTrash} onClick={onDeleteButtonClick} />
      </td>
    </tr>
  );
};
